import {INITIALIZA_TOKBOX} from "../types";

export const initializeTokBox = details => ({
    type: INITIALIZA_TOKBOX,
    payload: details
});